/**
 * Job Import Page
 *
 * Wrapper page for the Job Import Wizard.
 * Feature: #5182 - Import Job from Document or URL
 */

import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography, Breadcrumbs, Link } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import JobImportWizard from "../components/JobImportWizard/JobImportWizard";

const JobImportPage: React.FC = () => {
  const { t } = useTranslation(["recruiting", "common"]);

  return (
    <Box sx={{ p: 3 }}>
      <Breadcrumbs sx={{ mb: 2 }}>
        <Link
          component={RouterLink}
          to="/jobs"
          color="inherit"
          underline="hover"
        >
          {t("jobImport.page.breadcrumbs.jobs", "Jobs")}
        </Link>
        <Typography color="text.primary">
          {t("jobImport.page.breadcrumbs.import", "Import")}
        </Typography>
      </Breadcrumbs>

      <Typography variant="h4" gutterBottom>
        {t("jobImport.page.title", "Import Job")}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        {t(
          "jobImport.page.description",
          "Import a job from a document or URL. AI will extract the details for you to review before saving.",
        )}
      </Typography>

      <JobImportWizard />
    </Box>
  );
};

export default JobImportPage;
